import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import Map from "../components/Contact/MapContent";
import BaseLayout from "../components/global/BaseLayout";
import ContactInfo from "../components/Contact/ContactInfo2";

function Contact() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="Contact">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="Contact"
          Subheader="Contact"
          bgimg={`${rpdata?.gallery?.length > 14 ? rpdata?.gallery?.[14] : rpdata?.stock?.[14]}`}
        />
        <ContactInfo
          image1={rpdata?.gallery?.length > 5 ? rpdata?.gallery?.[5] : rpdata?.stock?.[5]}
          image={rpdata?.gallery?.length > 6 ? rpdata?.gallery?.[6] : rpdata?.stock?.[6]}
        />
        <Map />
      </div>
    </BaseLayout>
  );
}

export default Contact;
